window.getAttachment = function (id) {
    if (id === undefined || id == '')
        return;

    var data = {
        id: id
    }

    $.ajax({
        type: 'post',
        async: false,
        url: '/config/attachments',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data.message !== undefined) {
                console.log(data);
                return;
            }

            for (var i = 0; i < data.length; i++) {
                if (data[i].type == 1) {
                    $('img[src="' + data[i].id + '"]').attr('src', data[i].url + '?w=120&h=120&s=3');
                }
                else {
                    $('img[src="' + data[i].id + '"]').remove();
                }
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
};

window.toThread = function (data, body, bdelete) {
    var newlist = '';
    var attachments = '';
    var btnhtml = '';
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        var pichtml = '';
        if (info.attachments) {
            for (var j = 0; j < info.attachments.length; j++) {
                pichtml += '<img src="' + info.attachments[j] + '" />';
                attachments += info.attachments[j] + ',';
            }
        }
        if (bdelete)
            btnhtml = '<div class="item-btn delete" dataid="' + info.id + '"></div>';
        else
            btnhtml = '';

        if (!info.author_avatar_url) {
            info.author_avatar_url = '/static/images/no-avatar.png';
        } else {
            info.author_avatar_url += '?w=52&h=52&s=1';
        }

        newlist += '<div class="community-Item">\
            <div class="item-top">\
            <div class="item-avatar">\
            <img src="' + info.author_avatar_url + '">\
            </div>\
            <div class="item-user">\
            <div class="item-nickname">' + info.author_nickname + '</div>\
            <div class="item-time">' + info.post_time + '</div>\
            </div>\
            ' + btnhtml + '\
            </div>\
            <div class="item-middle">\
            <div class="item-picture">' + pichtml + '</div>\
            <div class="item-content part" href="' + info.url + '">' + info.content + '</div>\
            <div class="item-content-all">展开全文&nbsp∨</div> \
            </div>\
            <div class="item-bottom">\
            <div class="item-count"><div class="favorite">收藏</div></div>\
            <div class="item-count"><div class="reply">' + info.reply_count + '</div></div>\
            <div class="item-count"><div class="share">0</div></div>\
            <div class="item-count"><div class="like">点赞</div></div>\
            </div>\
            </div>';
    }

    body.append(newlist);

    getAttachment(attachments);

    $('.item-content-all').off('click');
    $('.item-content-all').on('click', function () {
        var body = $(this).parents().children('.item-content');
        if (body.hasClass('part')) {
            body.removeClass('part');
            body.addClass('all');
            $(this).text('收起全文 ∨');
        } else {
            body.removeClass('all');
            body.addClass('part');
            $(this).text('展开全文 ∧');
        }
    });
};

window.toFollow = function (data, body) {
    var newlist = '';

    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        newlist += '<div class="followItem">';
        if (info.follow_user_avatar_url == null || info.follow_user_avatar_url == '')
            info.follow_user_avatar_url = '/static/images/no-avatar.png';
        else
            info.follow_user_avatar_url += '?w=60&h=60&s=3';
        newlist += '<div class="follow-avatar"><img src="' + info.follow_user_avatar_url + '" /></div>';
        newlist += '<div class="follow-user">';
        newlist += '<div class="follow-name">' + info.follow_user_nickname + '</div>';
        if (info.signature == null || info.signature == '')
            info.signature = '';
        newlist += '<div class="follow-signature">' + info.signature + '</div>';
        newlist += '<div class="follow-btn followed" dataid="' + info.follow_user_id + '">取消关注</div>';
        newlist += '</div>';
        newlist += '</div>';
    }

    body.append(newlist);
};

window.toFans = function (data, body) {
    var newlist = '';

    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        newlist += '<div class="fanItem">';
        if (info.fan_user_avatar_url == null || info.fan_user_avatar_url == '')
            info.fan_user_avatar_url = '/static/images/no-avatar.png';
        else
            info.fan_user_avatar_url += '?w=60&h=60&s=3';
        newlist += '<div class="fan-avatar"><img src="' + info.fan_user_avatar_url + '" /></div>';
        newlist += '<div class="fan-user">';
        newlist += '<div class="fan-name">' + info.fan_user_nickname + '</div>';
        if (info.signature == null || info.signature == '')
            info.signature = '';
        newlist += '<div class="fan-signature">' + info.signature + '</div>';
        if (info.followed)
            newlist += '<div class="follow-btn followed" dataid="' + info.fan_user_id + '">取消关注</div>';
        else
            newlist += '<div class="follow-btn" dataid="' + info.fan_user_id + '">添加关注</div>';
        newlist += '</div>';
        newlist += '</div>';
    }

    body.append(newlist);
};

window.toLive = function (data, body, bdelete) {
    var newlist = '';
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];

        newlist += '<div class="liveitem" data-id="' + info.id + '">\
                        <a href="' + info.url + '" target="_blank" class="liveitem-img">\
                            <img src="' + info.cover_url + '">\
                            <div class="liveitem-state">' + info.state + '</div>\
                        </a>\
                        <a href="' + info.url + '" target="_blank" class="liveitem-title">\
                            ' + info.title + '\
                        </a>\
                        <div class="liveitem-info">\
                            <div class="liveitem-username">' + info.owner_nickname + '</div>\
                            <div class="liveitem-visitor">' + info.current_visitor_count + '人参与</div>\
                        </div>';
        if (bdelete)
            newlist += '<div class="live-delete" dataid="' + info.id + '">删除</div>';
        newlist += '</div>';
    }

    body.append(newlist);
};